import script from "./EventHeaderSection.vue?vue&type=script&setup=true&lang=js"
export * from "./EventHeaderSection.vue?vue&type=script&setup=true&lang=js"

import "./EventHeaderSection.vue?vue&type=style&index=0&id=8cc918f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8cc918f4"]])

export default __exports__